<template>
  <el-dialog v-model="dialogVisible"
             :title="t('views.vendors.newVendor')" @close="onDialogClose">
    <VendorForm
        :initVendor="initVendor"
        :submitAction="submit"
        enableClearForm
        clearFormOnSubmit
        className="new-vendor-dialog"
    />
  </el-dialog>

</template>
<script lang="ts" setup>
import {onMounted, ref, watch} from "vue"
import {useI18n} from "vue-i18n";
import VendorForm from "@/views/companies/vendors/VendorForm.vue";
import {useHTTP} from "@/plugins/http";
import Vendor from '@/models/vendor/Vendor'

const props = defineProps(['modelValue'])
const emits = defineEmits(['onOpen', 'update:modelValue', 'onSubmit'])
const {t} = useI18n({
  useScope: 'global',
  messages: {
    en: {
    },
    ar: {
    }
  }
});

const http = useHTTP();
const dialogVisible = ref(false);
const initVendor = ref(new Vendor());

onMounted(() => {
  dialogVisible.value = props.modelValue
});

watch(
    () => props.modelValue,
    (newValue: any, _) => {
      dialogVisible.value = newValue
    },
)

watch(() => dialogVisible, (newValue) => {
  emits('update:modelValue', newValue)
})

function onDialogClose() {
  dialogVisible.value = false;
  emits('update:modelValue', dialogVisible.value)
}

async function submit(vendor: Vendor) {
  try {
    const res = await http.post<Vendor>(Vendor.ENDPOINT, vendor)
    emits('onSubmit', res)
  } catch (error) {
    return error
  }
}
</script>
<style>
.new-vendor-dialog .input-section {
  width: 100% !important;
}

.new-vendor-dialog .el-form--label-top .el-form-item {
  display: block !important;
}
</style>
